import { computed }           from 'mobx';
import InvoicePrivateApiModel from '../../abstracts/InvoicePrivateApiModel';

export default class BillableMetaModel extends InvoicePrivateApiModel {
	public _filters: ModelFiltersExtended<{
		billable: id;
		reference: InvoiceBillableMetaReference;
	}> = {};

	static get path(): string {
		return '/billable_metas/{?id}';
	}

	@computed
	public get reference(): string {
		return this.get('reference');
	}

	@computed
	public get value(): string {
		return this.get('value');
	}

	public _sorts: ModelSortsExtended<{
		'id': string;
		'reference': string;
		'updatedAt': string;
		'value': string;
	}> = {};
}
